
import { CONTRACT_INDEX_PAYROLL_ACCOUNT, CHECKING_ACCOUNT } from "constants/index"

export const POE_KEY = {
    [CONTRACT_INDEX_PAYROLL_ACCOUNT]: {
        title: 'contractsView-fiocRequired_payrollAccountModalTitle',
        description: 'contractsView-fiocRequired_payrollAccountModalDescription',
    },
    [CHECKING_ACCOUNT]: {
        title: 'contractsView-fiocRequired_checkingAccountModalTitle',
        description: 'contractsView-fiocRequired_checkingAccountModalDescription',
    }
}
